var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty d-flex align-items-center justify-center flex-column"},[_c('img',{attrs:{"src":require("../../../assets/icons/empty.svg"),"alt":"empty area"}}),_c('h3',{staticClass:"empty__text"},[_vm._v("Пожалуйста, сначала выберите класс")])])
}]

export { render, staticRenderFns }